<template>
  <div class="sidebar">
    <div class="logo">
      <router-link :to="{ name: 'Dashboard' }">
        <img :src="getImageUrl('/images/logo.png')" />
      </router-link>
    </div>
    <ul class="button-sidebar">
      <li
        v-for="(link, index) in links"
        :key="index"
        :class="{ active: isRouteActive(link.name) }"
      >
        <!-- <img :src="getImageUrl('/images/user-menu-icons/settings-disable.png')"> -->
        <img :src="link.image" class="" />
        <router-link :to="{ name: link.name }" active-class="select">{{
          link.label
        }}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import profileMixin from "../mixins/profileMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [profileMixin],
  props: {
    role: {
      type: String,
      default: null,
    },
  },

  data: () => {
    return {
      active: false,
      links: [
        {
          label: "Users",
          name: "Admin users",
          image: [require("../assets/images/user-menu-icons/user.svg")],
        },
        {
          label: "Methods",
          name: "Admin methods",
          image: [require("../assets/images/user-menu-icons/setting.svg")],
        },
        {
          label: "Insights",
          name: "Admin insights",
          image: [require("../assets/images/user-menu-icons/insight.svg")],
        },
        {
          label: "Monitoring",
          name: "Admin monitoring",
          image: [require("../assets/images/user-menu-icons/monitoring.svg")],
        },
        {
          label: "Regimen",
          name: "Admin regimen",
          image: [require("../assets/images/user-menu-icons/regimn.svg")],
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },

  methods: {
    isRouteActive(routeName) {
      return this.$route.name === routeName;
    },
  },
};
</script>

<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
li {
  list-style-type: none;
  /* margin-top: 15px; */
}
svg {
  width: 20px;
  height: 19px;
  margin-right: 3px;
}
li a {
  color: #939eab;
  font-size: 20px;
}
.button-sidebar {
  color: #6e3f7f;
}

li img {
  height: 20px;
  width: 20px;
  margin-right: 10px;
}
.button-sidebar li {
  border-left: 4px solid transparent;
  padding: 10px;
  align-items: center;
}
.button-sidebar li:hover {
  border-left: 4px solid #e6a73f;
}
.button-sidebar li:hover a {
  color: #e6a73f;
}
.button-sidebar li:hover img {
  filter: brightness(0) saturate(100%) invert(81%) sepia(37%) saturate(1227%)
    hue-rotate(331deg) brightness(98%) contrast(83%);
}
.active img{
  filter: brightness(0) saturate(100%) invert(81%) sepia(37%) saturate(1227%)
    hue-rotate(331deg) brightness(98%) contrast(83%);
   
}
li.active{
  background-color: #EFE2CD;
}
.active a{
  color: #e6a73f;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminSidebar.vue